import { render, staticRenderFns } from "./NovedadesDrawer.vue?vue&type=template&id=9f619f26&scoped=true"
import script from "./NovedadesDrawer.vue?vue&type=script&lang=js"
export * from "./NovedadesDrawer.vue?vue&type=script&lang=js"
import style0 from "./NovedadesDrawer.vue?vue&type=style&index=0&id=9f619f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f619f26",
  null
  
)

export default component.exports